import { API_PHOTOGRAPHERS_V2_PATH, getKodakClient } from '../api';
import { Photographer, PhotographerSearchResult } from '../dtos';
import { serializeParams } from '../utils/serializer';

export async function searchPhotographers(queryString: string): Promise<PhotographerSearchResult[]> {
  const client = await getKodakClient();
  const { data } = await client.get<PhotographerSearchResult[]>(`${API_PHOTOGRAPHERS_V2_PATH}/search`, {
    params: serializeParams({ q: queryString }),
  });

  return data;
}

export async function getPhotographer(photographerId: Photographer['id']): Promise<Photographer> {
  const client = await getKodakClient();
  const { data } = await client.get<Photographer>(`${API_PHOTOGRAPHERS_V2_PATH}/${photographerId}`);

  return data;
}
